import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { BadgeModule } from '@sb/library/badge';
import { BaseModule } from '@sb/library/base';
import { IconModule } from '@sb/library/icon';
import { UtilityModule } from '@sb/library/utility';
import { ButtonGroupComponent } from './button-group/button-group.component';
import { ButtonToggleGroupComponent } from './button-toggle-group/button-toggle-group.component';
import { ButtonComponent } from './button.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { MenuButtonComponent } from './menu-button/menu-button.component';
import { MenuItemComponent } from './menu-button/menu-item/menu-item.component';
import { SplitButtonComponent } from './split-button/split-button.component';
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';

@NgModule({
    declarations: [
        ButtonComponent,
        MenuButtonComponent,
        MenuItemComponent,
        IconButtonComponent,
        SplitButtonComponent,
        ButtonGroupComponent,
        ToggleButtonComponent,
        ButtonToggleGroupComponent
    ],
    imports: [
        CommonModule,
        IconModule,
        MatMenuModule,
        MatTooltipModule,
        UtilityModule,
        MatDividerModule,
        BadgeModule,
        RouterModule,
        BaseModule
    ],
    exports:[
        ButtonComponent,
        MenuButtonComponent,
        MenuItemComponent,
        IconButtonComponent,
        SplitButtonComponent,
        ButtonGroupComponent,
        ToggleButtonComponent,
        ButtonToggleGroupComponent
    ]
})
export class ButtonModule { }
